import { compose, flattenProp } from 'recompose';
import { connect } from 'react-redux';
import combineSelectors from 'utils/combineSelectors';
import { theme } from 'reducers/dashboard/selectors';
import { addProps } from 'utils/recompose';

const mapStateToProps = combineSelectors({
  theme,
});

export const nameStyle = ({ name, theme }) =>
  name.length > 2
    ? { size: theme.sideNav.selectedNavLarge, fontFamily: theme.font }
    : { size: theme.sideNav.selectedNavSmall, fontFamily: theme.font };

export default compose(
  connect(mapStateToProps),
  flattenProp('series'),
  addProps({ nameStyle }),
);
